import { useAtomValue } from 'jotai';

import { scheduledPatientInformationAtom } from '../schedule-preview/state';
import { useGetPatientByShortId } from '../useGetPatientByShortId';
import { ClientInformationDrawerHeader, ClientInformationDrawerHeaderProps } from './ClientInformationDrawerHeader';
import { getAppointmentClientInfoHeader, getAppointmentType } from './utils';

export function ClientInformationDrawerHeaderWrapper({
  selectedPatientShortId,
  visitorName,
  ...rest
}: Omit<ClientInformationDrawerHeaderProps, 'drawerTitle'> & {
  selectedPatientShortId: string;
  visitorName?: string;
}) {
  const { data: patientChartData } = useGetPatientByShortId(selectedPatientShortId);
  const scheduledPatientInformation = useAtomValue(scheduledPatientInformationAtom);

  const appointmentType = getAppointmentType(
    scheduledPatientInformation?.appointmentType,
    patientChartData?.patientChart?.lastAppointment,
  );

  return (
    <ClientInformationDrawerHeader
      {...rest}
      drawerTitle={getAppointmentClientInfoHeader(appointmentType, visitorName)}
    />
  );
}
